// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-columns {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}
.safety-approval-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.safety-approval-modal {
  background: white;
  border-radius: 10px;
  width: 90%;
  max-width: 650px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.safety-approval-modal-header {
  background: #34495e;
  color: white;
  padding: 15px 20px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 10;
}

.safety-approval-modal-header h2 {
  color: white;
  margin: 0;
  font-size: 1.3rem;
  font-weight: 600;
}

.safety-approval-modal-close {
  background: none;
  border: none;
  color: white;
  font-size: 1.8rem;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: color 0.2s;
}

.safety-approval-modal-close:hover {
  color: #f39c12;
}

.safety-approval-modal-content {
  padding: 20px 30px;
  color: #2c3e50;
  line-height: 1.6;
}

.safety-approval-icon {
  text-align: center;
  margin-bottom: 20px;
}

.safety-approval-icon i {
  font-size: 5rem;
  color: #27ae60;
  animation: pulse 2s infinite;
}

.safety-approval-icon.safety-pending i {
  color: #f39c12;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

.safety-status-approved {
  color: #27ae60;
  font-weight: bold;
}

.safety-status-pending {
  color: #f39c12;
  font-weight: bold;
}

.safety-approval-greeting {
  font-size: 1.1rem;
  font-weight: 500;
  margin-bottom: 15px;
}

.safety-approval-signature {
  margin-top: 25px;
  font-style: italic;
}

.safety-approval-modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  background: #f5f5f5;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.safety-approval-modal-button {
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}

.safety-approval-modal-button.primary {
  background-color: #3498db;
  color: white;
  border: none;
}

.safety-approval-modal-button.primary:hover {
  background-color: #2980b9;
}

.safety-approval-modal-button.secondary {
  background-color: white;
  color: #3498db;
  border: 1px solid #3498db;
}

.safety-approval-modal-button.secondary:hover {
  background-color: #f0f8ff;
}

/* Status Banner */
.safety-approval-status-banner {
  background: #f0f3f6;
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.safety-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 20px;
  margin-bottom: 15px;
  font-weight: 600;
}

.safety-status-badge.safety-status-approved {
  background-color: rgba(46, 204, 113, 0.1);
  color: #27ae60;
  border: 1px solid #2ecc71;
}

.safety-status-badge.safety-status-pending {
  background-color: rgba(46, 204, 113, 0.1);
  color: #27ae60;
  border: 1px solid #2ecc71;
}
.safety-status-badge i {
  margin-right: 8px;
}

.safety-status-details {
  margin-top: 15px;
}
.safety-status-updated {
  font-size: 0.85rem;
  color: #6c757d;
}
.status-card{
  background-color: rgb(255, 255, 255);
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s;
}
.safety-status-content{
  padding: 1.5rem;
}
.safety-status-card:hover{
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}
.status-card-header {
  background-color: #2734ae;
  padding: 1rem;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.safety-status-badge i {
  margin-right: 8px;
}

.safety-status-details {
  margin-top: 15px;
}
/* History Section */
.safety-approval-notification-section {
  margin-top: 25px;
  border-top: 1px dashed #e0e0e0;
  padding-top: 15px;
}

.safety-approval-history-toggle {
  background: none;
  border: none;
  color: #3498db;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 0;
  font-weight: 500;
  width: 100%;
  text-align: left;
}

.safety-approval-history-toggle:hover {
  color: #2980b9;
}

.safety-approval-history {
  margin-top: 15px;
  background: #f9f9f9;
  padding: 15px;
  border-radius: 6px;
}

.safety-approval-history h3 {
  margin-top: 0;
  font-size: 1.1rem;
  margin-bottom: 15px;
  color: #2c3e50;
}

.safety-approval-timeline {
  position: relative;
}

.safety-approval-timeline:before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 18px;
  width: 2px;
  background: #d1d1d1;
}

.safety-approval-timeline-item {
  display: flex;
  margin-bottom: 15px;
  position: relative;
}

.safety-approval-timeline-marker {
  position: relative;
  margin-right: 15px;
  z-index: 1;
}

.safety-approval-timeline-marker i {
  background: white;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #d1d1d1;
  color: #3498db;
}

.safety-approval-timeline-content {
  flex: 1 1;
  background: white;
  padding: 10px 15px;
  border-radius: 5px;
  border-left: 3px solid #3498db;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.safety-approval-timeline-date {
  font-size: 0.8rem;
  color: #6c757d;
  margin: 0 0 5px 0;
}

.safety-approval-timeline-message {
  margin: 5px 0;
  font-weight: 500;
}

.safety-approval-timeline-admin {
  font-size: 0.85rem;
  font-style: italic;
  margin: 5px 0 0 0;
  color: #6c757d;
}

.safety-approval-contact {
  margin-top: 20px;
  padding: 15px;
  background: #e9f7fe;
  border-left: 3px solid #3498db;
  border-radius: 3px;
}

.safety-approval-contact a {
  color: #2980b9;
  text-decoration: none;
}

.safety-approval-contact a:hover {
  text-decoration: underline;
}
/* On larger screens, show two columns */
@media (min-width: 992px) {
  .dashboard-columns {
    grid-template-columns: 1fr 1fr;
    max-width: 1200px;
  }
}
/* Responsive Adjustments */
@media (max-width: 768px) {
  .safety-approval-modal {
    width: 95%;
    margin: 10px;
  }
  
  .safety-approval-status-banner {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .safety-approval-modal-footer {
    flex-direction: column;
  }
  
  .safety-approval-modal-button {
    width: 100%;
    margin-bottom: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/UserDashboard/ApprovalModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,qBAAqB,EAAE;EAC7B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;AACA,wCAAwC;AACxC;EACE;IACE,8BAA8B;IAC9B,iBAAiB;EACnB;AACF;AACA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;AACF","sourcesContent":[".dashboard-columns {\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  gap: 20px;\r\n  width: 100%;\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n}\r\n.safety-approval-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.7);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n  animation: fadeIn 0.3s ease-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n.safety-approval-modal {\r\n  background: white;\r\n  border-radius: 10px;\r\n  width: 90%;\r\n  max-width: 650px;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);\r\n  display: flex;\r\n  flex-direction: column;\r\n  animation: slideIn 0.3s ease-out;\r\n}\r\n\r\n@keyframes slideIn {\r\n  from { transform: translateY(20px); opacity: 0; }\r\n  to { transform: translateY(0); opacity: 1; }\r\n}\r\n\r\n.safety-approval-modal-header {\r\n  background: #34495e;\r\n  color: white;\r\n  padding: 15px 20px;\r\n  border-top-left-radius: 10px;\r\n  border-top-right-radius: 10px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n}\r\n\r\n.safety-approval-modal-header h2 {\r\n  color: white;\r\n  margin: 0;\r\n  font-size: 1.3rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.safety-approval-modal-close {\r\n  background: none;\r\n  border: none;\r\n  color: white;\r\n  font-size: 1.8rem;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  line-height: 1;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.safety-approval-modal-close:hover {\r\n  color: #f39c12;\r\n}\r\n\r\n.safety-approval-modal-content {\r\n  padding: 20px 30px;\r\n  color: #2c3e50;\r\n  line-height: 1.6;\r\n}\r\n\r\n.safety-approval-icon {\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.safety-approval-icon i {\r\n  font-size: 5rem;\r\n  color: #27ae60;\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n.safety-approval-icon.safety-pending i {\r\n  color: #f39c12;\r\n}\r\n\r\n@keyframes pulse {\r\n  0% { transform: scale(1); }\r\n  50% { transform: scale(1.1); }\r\n  100% { transform: scale(1); }\r\n}\r\n\r\n.safety-status-approved {\r\n  color: #27ae60;\r\n  font-weight: bold;\r\n}\r\n\r\n.safety-status-pending {\r\n  color: #f39c12;\r\n  font-weight: bold;\r\n}\r\n\r\n.safety-approval-greeting {\r\n  font-size: 1.1rem;\r\n  font-weight: 500;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.safety-approval-signature {\r\n  margin-top: 25px;\r\n  font-style: italic;\r\n}\r\n\r\n.safety-approval-modal-footer {\r\n  padding: 15px 20px;\r\n  border-top: 1px solid #e0e0e0;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 10px;\r\n  background: #f5f5f5;\r\n  border-bottom-left-radius: 10px;\r\n  border-bottom-right-radius: 10px;\r\n}\r\n\r\n.safety-approval-modal-button {\r\n  padding: 10px 20px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.safety-approval-modal-button.primary {\r\n  background-color: #3498db;\r\n  color: white;\r\n  border: none;\r\n}\r\n\r\n.safety-approval-modal-button.primary:hover {\r\n  background-color: #2980b9;\r\n}\r\n\r\n.safety-approval-modal-button.secondary {\r\n  background-color: white;\r\n  color: #3498db;\r\n  border: 1px solid #3498db;\r\n}\r\n\r\n.safety-approval-modal-button.secondary:hover {\r\n  background-color: #f0f8ff;\r\n}\r\n\r\n/* Status Banner */\r\n.safety-approval-status-banner {\r\n  background: #f0f3f6;\r\n  padding: 15px;\r\n  border-radius: 6px;\r\n  margin-bottom: 20px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.safety-status-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 8px 16px;\r\n  border-radius: 20px;\r\n  margin-bottom: 15px;\r\n  font-weight: 600;\r\n}\r\n\r\n.safety-status-badge.safety-status-approved {\r\n  background-color: rgba(46, 204, 113, 0.1);\r\n  color: #27ae60;\r\n  border: 1px solid #2ecc71;\r\n}\r\n\r\n.safety-status-badge.safety-status-pending {\r\n  background-color: rgba(46, 204, 113, 0.1);\r\n  color: #27ae60;\r\n  border: 1px solid #2ecc71;\r\n}\r\n.safety-status-badge i {\r\n  margin-right: 8px;\r\n}\r\n\r\n.safety-status-details {\r\n  margin-top: 15px;\r\n}\r\n.safety-status-updated {\r\n  font-size: 0.85rem;\r\n  color: #6c757d;\r\n}\r\n.status-card{\r\n  background-color: rgb(255, 255, 255);\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\r\n  overflow: hidden;\r\n  transition: all 0.3s;\r\n}\r\n.safety-status-content{\r\n  padding: 1.5rem;\r\n}\r\n.safety-status-card:hover{\r\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\r\n}\r\n.status-card-header {\r\n  background-color: #2734ae;\r\n  padding: 1rem;\r\n  color: white;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n.safety-status-badge i {\r\n  margin-right: 8px;\r\n}\r\n\r\n.safety-status-details {\r\n  margin-top: 15px;\r\n}\r\n/* History Section */\r\n.safety-approval-notification-section {\r\n  margin-top: 25px;\r\n  border-top: 1px dashed #e0e0e0;\r\n  padding-top: 15px;\r\n}\r\n\r\n.safety-approval-history-toggle {\r\n  background: none;\r\n  border: none;\r\n  color: #3498db;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 5px 0;\r\n  font-weight: 500;\r\n  width: 100%;\r\n  text-align: left;\r\n}\r\n\r\n.safety-approval-history-toggle:hover {\r\n  color: #2980b9;\r\n}\r\n\r\n.safety-approval-history {\r\n  margin-top: 15px;\r\n  background: #f9f9f9;\r\n  padding: 15px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.safety-approval-history h3 {\r\n  margin-top: 0;\r\n  font-size: 1.1rem;\r\n  margin-bottom: 15px;\r\n  color: #2c3e50;\r\n}\r\n\r\n.safety-approval-timeline {\r\n  position: relative;\r\n}\r\n\r\n.safety-approval-timeline:before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 18px;\r\n  width: 2px;\r\n  background: #d1d1d1;\r\n}\r\n\r\n.safety-approval-timeline-item {\r\n  display: flex;\r\n  margin-bottom: 15px;\r\n  position: relative;\r\n}\r\n\r\n.safety-approval-timeline-marker {\r\n  position: relative;\r\n  margin-right: 15px;\r\n  z-index: 1;\r\n}\r\n\r\n.safety-approval-timeline-marker i {\r\n  background: white;\r\n  border-radius: 50%;\r\n  width: 36px;\r\n  height: 36px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: 2px solid #d1d1d1;\r\n  color: #3498db;\r\n}\r\n\r\n.safety-approval-timeline-content {\r\n  flex: 1;\r\n  background: white;\r\n  padding: 10px 15px;\r\n  border-radius: 5px;\r\n  border-left: 3px solid #3498db;\r\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\r\n}\r\n\r\n.safety-approval-timeline-date {\r\n  font-size: 0.8rem;\r\n  color: #6c757d;\r\n  margin: 0 0 5px 0;\r\n}\r\n\r\n.safety-approval-timeline-message {\r\n  margin: 5px 0;\r\n  font-weight: 500;\r\n}\r\n\r\n.safety-approval-timeline-admin {\r\n  font-size: 0.85rem;\r\n  font-style: italic;\r\n  margin: 5px 0 0 0;\r\n  color: #6c757d;\r\n}\r\n\r\n.safety-approval-contact {\r\n  margin-top: 20px;\r\n  padding: 15px;\r\n  background: #e9f7fe;\r\n  border-left: 3px solid #3498db;\r\n  border-radius: 3px;\r\n}\r\n\r\n.safety-approval-contact a {\r\n  color: #2980b9;\r\n  text-decoration: none;\r\n}\r\n\r\n.safety-approval-contact a:hover {\r\n  text-decoration: underline;\r\n}\r\n/* On larger screens, show two columns */\r\n@media (min-width: 992px) {\r\n  .dashboard-columns {\r\n    grid-template-columns: 1fr 1fr;\r\n    max-width: 1200px;\r\n  }\r\n}\r\n/* Responsive Adjustments */\r\n@media (max-width: 768px) {\r\n  .safety-approval-modal {\r\n    width: 95%;\r\n    margin: 10px;\r\n  }\r\n  \r\n  .safety-approval-status-banner {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 10px;\r\n  }\r\n  \r\n  .safety-approval-modal-footer {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .safety-approval-modal-button {\r\n    width: 100%;\r\n    margin-bottom: 10px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
